import { ChangeDetectorRef, Directive, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { DataBindingDirective as KendoDataBindingDirective, GridComponent } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';

import { GridDataSourceService } from '../services/grid-data-source.service';
import { finalize } from 'rxjs/operators';

@Directive({
  selector: '[appDataBinding]',
})
export class GridDataBindingDirective extends KendoDataBindingDirective implements OnInit, OnDestroy, OnChanges {
  @Input('appDataBinding') service: GridDataSourceService;

  private subscription: Subscription;

  constructor(private cd: ChangeDetectorRef, protected grid: GridComponent) {
    super(grid);
    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.service.subscribe(result => {
        this.grid.data = result;
        this.notifyDataChange();
      }),
    );

    super.ngOnInit();

    this.rebind();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();

    super.ngOnDestroy();
  }

  getState() {
    return this.state;
  }

  rebind(): void {
    this.grid.loading = true;
    this.cd.markForCheck();
    this.subscription.add(
      this.service
        .query(this.state)
        .pipe(
          finalize(() => {
            this.grid.loading = false;
            this.cd.markForCheck();
          }),
        )
        .subscribe(),
    );
  }
}
